import { render, staticRenderFns } from "./HomeFeedTrash.vue?vue&type=template&id=2e7c7331"
import script from "./HomeFeedTrash.vue?vue&type=script&lang=js"
export * from "./HomeFeedTrash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports